import { render, staticRenderFns } from "./picSwipe.vue?vue&type=template&id=0d273c09&scoped=true&"
import script from "./picSwipe.vue?vue&type=script&lang=js&"
export * from "./picSwipe.vue?vue&type=script&lang=js&"
import style0 from "./picSwipe.vue?vue&type=style&index=0&id=0d273c09&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d273c09",
  null
  
)

export default component.exports